import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import FormFooter, { FormFooterCol } from "@insightfulscience/atomic-react/r1/molecules/FormFooter";
import { FormSubmit } from "@insightfulscience/atomic-react/r1/atoms/FormSubmit";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import RequestSponsorshipFields from "./RequestSponsorshipFields";
import { requestSponsorshipForm } from "./action";

const RequestSponsorshipForm = () => {
	const [t] = useLocale("request-sponsorship-form");
	const [action, { isLoading }] = useFormAction(requestSponsorshipForm);

	return (
		<>
			{isLoading && <Spinner />}
			<RequestSponsorshipFields action={action}>
				<FormFooter>
					<FormFooterCol textAlign="left">
						<FormSubmit submitQASelector="request-sponsorship-form-submit-btn">
							{t("REQUEST")}
						</FormSubmit>
					</FormFooterCol>
				</FormFooter>
			</RequestSponsorshipFields>
		</>
	);
};

export default RequestSponsorshipForm;
